import React, {useEffect, useState} from 'react';
import {AgChartsReact} from "ag-charts-react";
import localStrings from "../localStrings";
import useAuth from "../hooks/useAuth";
import {Box, CircularProgress} from "@mui/material";
import useAppUtil from "../hooks/useAppUtil";
import {getDataSingleDay, getDataWeekOrMonth} from "./PieGraphUtils";
import {filterSingleDay} from "../pages/Home/FilterInfoOverview";
import {executeQueryUtil} from "../utils/gqlUtil";
import {getOptionListsQuery} from "../gql/OptionListsGql";
import {getProductsQuery} from "../gql/ProductGql";
import {getProductsData} from "../utils/productsParserUtil";
import {getStaffsQuery} from "../gql/StaffGql";

function PieTurnover({ordersData, mergedSumUpDayProductsFiltered, productData, displayMode, title,
                       additionalFilters, transformer, unity, product, mapOptionOptionList, currentOption}) {
  const {orders, mergedSumUpDay, filter, currentEstablishment, currentBrand} = useAuth();
  const {addError} = useAppUtil();
  const [options, setOptions] = useState(null);
  const [currency, setCurrency] = useState("€");
  const [optionLists, setOptionLists] = useState(null);
  const [products, setProducts] = useState(null);
  const [staffs, setStaffs] = useState(null);
  const [compute, setCompute] = useState(false);

  useEffect(() => {
    if (!currentBrand() || !currentEstablishment()) {
      return
    }

    const loadData = async () => {
      const resOptionLists = await executeQueryUtil(getOptionListsQuery(currentBrand().id, currentEstablishment().id));
      setOptionLists(resOptionLists?.data?.getOptionLists.map(x => JSON.parse(x.content)));

      const productsData = await getProductsData(currentBrand().id, currentEstablishment().id)

      setProducts(productsData);

      const resStaff = await executeQueryUtil(getStaffsQuery(currentBrand().id, currentEstablishment().id));
      setStaffs(resStaff?.data?.getStaffs);

    }
    loadData()
  }, [currentBrand(), currentEstablishment()]);


  useEffect(() => {
    if (filter && filter?.filterType === filterSingleDay) {
      setOptionsWithDataSource(getDataSingleDay(ordersData || orders, displayMode, additionalFilters, transformer), title, unity)
    }

    else if (optionLists && mergedSumUpDay && products && staffs) {
      setOptionsWithDataSource(getDataWeekOrMonth(mergedSumUpDayProductsFiltered, mergedSumUpDay, products || [], staffs || [], displayMode, product, mapOptionOptionList), title, unity)
    }

  }, [orders, ordersData, productData, optionLists, mergedSumUpDay, filter, products, staffs])


  function rendererTooltip ({ datum }) {
    return {
      content: `${datum.amount} ${unity || currency}` ,
      title: datum.asset
    };
  }

  function setOptionsWithDataSource(dataSource, title, unity) {
    setOptions({
      data: dataSource,
      title: {
        text: title || "",
      },

      series: [
        {
          type: "pie",
          angleKey: "amount",
          calloutLabelKey: "asset",
          sectorLabelKey: "amount",
          tooltip: {
            renderer: rendererTooltip,
          },
          sectorLabel: {
            color: "white",
            fontWeight: "bold",
            formatter: ({ value }) => `${value} ${unity || currency}`.trim()
          },
        },
      ],
    });
  }

  return (
      <div className="ag-material"
           style={{
             height: '500px',
             zIndex: '0 !important'
           }}
      >
        {options &&
            <AgChartsReact options={options}/>
        }

      </div>
  )
}

export default PieTurnover